// extracted by mini-css-extract-plugin
export default {"project":"styles_project__e048W","isHighlighted":"styles_isHighlighted__UhCJh","tags":"styles_tags__JexZq","title":"styles_title__sm-zy","actions":"styles_actions__wsNa+"};